import * as React from "react";

function SvgSearchIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.276 11.347l-.284.35.318.319 4.629 4.628a.209.209 0 01-.26.323l-.048-.041-4.615-4.615-.32-.32-.35.285a6.347 6.347 0 11.93-.93zm-4.929-9.93a5.93 5.93 0 100 11.86 5.93 5.93 0 000-11.86z"
                fill="#000"
                stroke="#000"
            />
        </svg>
    );
}

export default SvgSearchIcon;
